export interface RegisterState {
    user: {
        name: string;
        email: string;
        password: string;
        campaign_params: {
            utm_campaign: string,
            utm_medium: string,
            utm_source: string
        };
        not_finished_registration: boolean;
        use_account_system: boolean;
        productIntent: string
    };
    error: {
        name: string;
        email: string;
        password: string;
    };
    popover: boolean;
    saving: boolean;
    captchaToken: string;
};

export const initialRegisterState: RegisterState = {
    user: {
        name: '',
        email: '',
        password: '',
        campaign_params: {
            utm_campaign: '',
            utm_medium: '',
            utm_source: ''
        },
        not_finished_registration: true,
        use_account_system: false,
        productIntent: undefined
    },
    error: {
        name: '',
        email: '',
        password: ''
    },
    popover: false,
    saving: false,
    captchaToken: ''
};
